import ScProductsAttributeFilter from '../components/sc-products-attribut-filter';

const scProductsDetails = () => {
  if(document.querySelector('.mod_sc_data_reader .product-detail') && document.getElementById('group-products').querySelectorAll('tbody tr')) {
    new ScProductsAttributeFilter(document.querySelector('.mod_sc_data_reader .product-detail'), document.getElementById('group-products').querySelectorAll('tbody tr'));
  }
}

export default scProductsDetails;
